import { blockName, initializeBlock } from "../block";
import { initializeFrontendBlocks } from "../../blocks";

initializeFrontendBlocks(blockName, initializeBlock);

var rad = document.querySelectorAll('.priceVal');
var donationForm = document.getElementById('donation-form');
var annetCustom = document.getElementById('option4');
var annetInput = document.getElementById('option3');
var annetLabel = document.querySelector('label[for="option3"]');

let giTypeValue;
const giTypeInputs = document.querySelectorAll('input.gi-type');
giTypeInputs.forEach(giTypeInput => {
	giTypeInput.addEventListener( 'click', function () {
		giTypeValue = giTypeInput.value;

		// Reset gateway selection when transaction type is changed.
		donationForm.querySelectorAll('input.gateway').forEach(element => {
			element.checked = false;
		});

		// Select first available payment method.
		donationForm.querySelector('.gateway-' + giTypeValue + ' input').checked = true;

		donationForm.className = '';
		donationForm.classList.add(giTypeValue);
		if ( 'gave' === giTypeValue ) {
			donationForm.action = '/stottespiller/enkeltgaver/gi-en-gave/';
		} else {
			donationForm.action = '/bli-fast-giver/';
		}
  	});
});

for ( var i = 0; i < rad.length; i++ ) {
    rad[i].addEventListener('change', function() {
        if ( ! this.value ) {
			annetLabel.style.display = 'none';
			annetCustom.style.display = 'block';
			annetCustom.focus();
			annetCustom.addEventListener("keydown", () => {
				setTimeout(function() {
					annetInput.value = annetCustom.value;
				}, 0);
			});
        } else {
			if ( this.id !== 'option4' ) {
				annetLabel.style.display = 'block';
				annetCustom.style.display = 'none';
				annetInput.value = '';
			}
        }
    });
}
